import { hasAnyPerm, hasAllPerm, isPlatformUser } from "@/utils/permission";

/**
 * v-perm 指令（RBAC 按钮级权限）
 *
 * 用法：
 *   v-perm="'device:archive:edit'"
 *   v-perm="['a:view','b:view']"          默认任一满足
 *   v-perm.all="['a:edit','b:edit']"      全部满足
 *   v-perm.disable="'device:archive:edit'" 置灰而不是移除
 *   v-perm.platform="'my:package:view'"   额外要求平台侧身份
 *
 * ⚠️⚠️ 铁律：v-if / v-else 配对处【禁止】使用 v-perm —— 本指令走 removeChild，
 *    会让 v-else 失去前驱元素 → Vue 编译报错。请改用 v-if="$hasPerm('码')"。
 */
export default {
  inserted(el, binding) {
    const { modifiers } = binding;
    let value = binding.value;
    const codes = Array.isArray(value) ? value : [value];

    let ok = modifiers.all ? hasAllPerm(codes) : hasAnyPerm(codes);
    if (modifiers.platform) {
      ok = ok && isPlatformUser();
    }
    if (ok) return;

    if (modifiers.disable) {
      el.classList.add("is-disabled");
      el.setAttribute("disabled", "disabled");
      el.style.pointerEvents = "none";
      el.style.opacity = "0.45";
      return;
    }

    // 未通过 → 移除节点
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    } else {
      el.style.display = "none";
    }
  },
};
